module.exports = __webpack_public_path__ + "img/logo.3d287bc3.png";